/* CaniCatiCare 멤버십 콘텐츠 페이지 — 조선멤버십 레이아웃 참고 */

const S = {
  catLabel: { fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '11px', color: '#DD0000' },
  hl: (sz = 16) => ({
    fontFamily: 'Noto Serif KR, Georgia, serif',
    fontWeight: 700,
    color: '#1A1A1A',
    fontSize: `${sz}px`,
    lineHeight: 1.45,
    cursor: 'pointer',
  }),
  mono: { fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: '#AAA' },
};

function Photo({ label, h, bg = '#1A1A1A' }) {
  return (
    <div style={{ height: h, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '10px', color: 'rgba(255,255,255,0.2)' }}>{label}</span>
    </div>
  );
}

/* 프리미엄 시계 뱃지 */
function Premium() {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '14px', height: '14px', borderRadius: '50%', border: '1.5px solid #888', marginLeft: '4px', verticalAlign: 'middle', flexShrink: 0 }}>
      <span style={{ fontSize: '8px', color: '#888', lineHeight: 1 }}>C</span>
    </span>
  );
}

/* ─── 데이터 ──────────────────────────────── */

const featured = {
  cat: 'CaniCatiCare 멤버십',
  label: '수의사 추천 케어',
  hl: "'강아지 관절염' 수술 없이\n관리하는 최신 치료법",
  premium: true,
  bg: '#0D1F17',
};

const centerItems = [
  {
    cat: '건강 리셋',
    hl: '정제 사료, 과도한 간식, 불규칙한 산책\n비만 반려견을 만드는 세 가지 악습',
    premium: true,
    bg: '#1A2A3A',
  },
  {
    cat: 'CaniCati STORY',
    hl: '딸깍딸깍\n매일 밤 고양이가 발을 핥는 진짜 이유',
    premium: false,
    bg: '#2A1A2A',
  },
];

const rightList = [
  {
    cat: '수의사 칼럼',
    hl: '고양이가 물을 안 마시는 이유… 신장 망가지기 전에 읽어야 할 글',
    premium: true,
    bg: '#2A3A1A',
  },
  {
    cat: '반려동물 영양학',
    hl: '오르면 건강, 내리면 위험\n혈당이 반려견 수명을 좌우한다',
    premium: true,
    bg: '#1A1A3A',
  },
  {
    cat: 'WEEKLY PET BIZ',
    hl: '펫푸드 시장의 역설…\n프리미엄 사료가 오히려 독이 되는 경우',
    premium: true,
    bg: '#3A2A1A',
  },
  {
    cat: '원장 에세이',
    hl: '"마지막 진료실에서\n보호자에게 하지 못한 말"',
    premium: true,
    bg: '#1A2A2A',
  },
  {
    cat: '오늘의 특가',
    hl: '멤버십 회원 15% 추가 할인\n강아지 관절 영양제 한 통 9,900원 초특가',
    premium: false,
    bg: '#3A3A1A',
    sale: true,
  },
];

/* ─── 컴포넌트 ────────────────────────────── */

export default function NewsPage() {
  return (
    <div className="max-w-7xl mx-auto px-6" style={{ paddingTop: '24px', paddingBottom: '32px' }}>

      {/* 멤버십 헤더 */}
      <div className="flex flex-wrap items-center gap-2" style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #1A1A1A' }}>
        <span style={{ fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 900, fontSize: '20px', color: '#1A1A1A' }}>
          CaniCatiCare 멤버십
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '22px', height: '22px', borderRadius: '50%', border: '2px solid #1A1A1A' }}>
          <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontWeight: 700, fontSize: '11px', color: '#1A1A1A' }}>C</span>
        </span>
        <span className="hidden md:inline" style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#AAA', marginLeft: '6px' }}>
          반려 동물의 지속 가능한 내일을 위한 프리미엄 콘텐츠
        </span>
        <a href="/#" className="ml-auto" style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', color: 'white', background: '#DD0000', padding: '5px 14px', textDecoration: 'none' }}>
          멤버십 가입
        </a>
      </div>

      {/* 3단 본문 */}
      <div className="flex flex-col md:flex-row" style={{ gap: '0' }}>

        {/* ── 좌측: 대형 피처드 ── */}
        <div className="md:flex-[0_0_38%] md:border-r border-[#E5E5E5] pb-4 md:pb-0 md:pr-5" style={{ cursor: 'pointer' }}>
          <Photo label="강아지 관절 치료 현장" h="320px" bg={featured.bg} />
          <div style={{ marginTop: '10px' }}>
            <p style={S.catLabel}>{featured.label}</p>
            <h2 style={{ ...S.hl(24), margin: '6px 0 0', letterSpacing: '-0.02em' }}>
              {featured.hl.split('\n').map((l, j) => (
                <span key={j}>{l}{j === 0 && <br />}</span>
              ))}
              {featured.premium && <Premium />}
            </h2>
          </div>
        </div>

        {/* ── 중앙: 2단 스택 ── */}
        <div className="md:flex-[0_0_28%] md:border-r border-[#E5E5E5] flex flex-col pb-4 md:pb-0" style={{ padding: '0 20px' }}>
          {centerItems.map((a, i) => (
            <div key={i} style={{ paddingBottom: i === 0 ? '16px' : '0', paddingTop: i === 1 ? '16px' : '0', borderBottom: i === 0 ? '1px solid #E5E5E5' : 'none', cursor: 'pointer', flex: 1 }}>
              <Photo label={a.cat} h="168px" bg={a.bg} />
              <p style={{ ...S.catLabel, marginTop: '8px' }}>{a.cat}</p>
              <h3 style={{ ...S.hl(15), marginTop: '4px' }}>
                {a.hl.split('\n').map((l, j) => (
                  <span key={j}>{l}{j === 0 && <br />}</span>
                ))}
                {a.premium && <Premium />}
              </h3>
            </div>
          ))}
        </div>

        {/* ── 우측: 썸네일 리스트 ── */}
        <div className="md:flex-1" style={{ paddingLeft: '20px' }}>
          {rightList.map((a, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'flex-start', gap: '12px',
              padding: '10px 0',
              borderBottom: i < rightList.length - 1 ? '1px solid #F0F0F0' : 'none',
              cursor: 'pointer',
            }}>
              {/* 텍스트 */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{
                  ...S.catLabel,
                  color: a.sale ? '#0066CC' : '#DD0000',
                  marginBottom: '4px',
                }}>
                  {a.cat}
                </p>
                <p style={{ ...S.hl(13), lineHeight: 1.5 }}>
                  {a.hl.split('\n').map((l, j) => (
                    <span key={j}>{l}{j === 0 && <br />}</span>
                  ))}
                  {a.premium && <Premium />}
                </p>
              </div>
              {/* 썸네일 */}
              <div style={{ width: '72px', height: '56px', flexShrink: 0, background: a.bg, border: '1px solid #E5E5E5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: a.sale ? '20px' : '18px' }}>
                  {i === 0 ? '🐱' : i === 1 ? '📊' : i === 2 ? '🐾' : i === 3 ? '🏥' : '🦴'}
                </span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
